import { Letter } from './../api/letter/letter';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BACKEND_URL } from '../app.config';
import { ListResult } from '../api/data-model';

@Injectable({
  providedIn: 'root'
})
export class LetterService {

  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) {

  }

  getList(): Observable<ListResult<Letter>> {
    return this.http.get<ListResult<Letter>>(this.baseUrl + '/api/app/letter/letters');
  }

  getListArray(): Observable<Letter[]> {
    return this.http.get<Letter[]>(this.baseUrl + '/api/app/letter/letters');
  }

  updateLetterTemplate(letterId: string,letter: Letter): Observable<Letter> {
    return this.http.put<Letter>(this.baseUrl + `/api/app/letter/${letterId}/letter`, letter);
  }

  getLetterTemplate(letterId: string): Observable<Letter> {
    return this.http.get<Letter>(this.baseUrl + `/api/app/letter/${letterId}/letter`);
  }

  addletterTemplate(letter: Letter): Observable<Letter> {
    return this.http.post<Letter>(this.baseUrl + '/api/app/letter/letter', letter);
  }
}
